<template>
  <div class="a">
    <Nav/>
    <PageBannerSmall :banner="banner"></PageBannerSmall>
    <Honor/>
    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerSmall from '@/components/PageBannerSmall'
import Honor from '@/components/Honor'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerSmall,
    Honor,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/honor-banner.jpg"),
        title: "因为肯定 所以相信",
        sub: "来自社会和公众的荣誉与奖项"
      }
    }
  }
}
</script>

<style scoped lang="less">
.a{
  .b{
    font-size: 30px;
  }
}
</style>